import * as React from 'react'
// components
import { Header } from 'components/Modals/PlanItems/styles'
import { DrawerModal } from 'components/UI'
// view components
import HistoryTable from './components/Table'
// hooks
import { useModalData } from 'hooks/index'
// constants
import { Modals } from 'constants/index'
// themes
import { CloseIcon } from 'components/UI/Icons'
// views
import { Wrapper, FieldTitle } from './views'
// types
import { IField } from 'types/graphql'

const FieldHistoryDrawer: React.FC = () => {
  const {
    hideModal,
    modalData: { isOpen, field, riskId, fieldValueId }
  } = useModalData<{ riskId?: string; field: IField; fieldValueId: string }>({
    modalType: Modals.RISK_FIELD_HISTORY_MODAL
  })

  if (!field) {
    return null
  }

  return (
    <DrawerModal width='700px' isOpen={isOpen} hideModal={hideModal}>
      <Header>
        History
        <CloseIcon onClick={hideModal} />
      </Header>
      <Wrapper>
        <FieldTitle>{field.label}</FieldTitle>
        <HistoryTable field={field} riskId={riskId} fieldValueId={fieldValueId} />
      </Wrapper>
    </DrawerModal>
  )
}

export default FieldHistoryDrawer
